import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageViewed } from 'src/Services/Mixpanel/events';
import { useUserConsent } from 'src/Services/UserConsentProvider/context';

const PAGE_NAMES: Record<string, string> = {
  dashboard: 'Tableau de bord',
  planning: 'Planning',
  contacts: 'Contacts',
  documents: 'Documents',
  infos: 'Informations',
  'practical-info': 'Informations pratiques',
  guides: 'Guides',
  instructions: 'Consignes',
  checklists: 'Checklists',
  expenses: 'Budget',
  admin: 'Administration',
  'project-and-works': 'Projets et travaux',
  tasks: 'Taches',
  community: 'Communaute',
  profile: 'Profil',
  meetings: 'Reunions',
  inventories: 'Inventaires',
  'incidents-and-claims': 'Incidents et sinistres',
  help: 'Aide',
  maintenance: 'Maintenance',
  templates: 'Modeles',
  auth: 'Connexion',
  onboarding: 'Onboarding',
  join: 'Rejoindre',
  export: 'Export',
  'accept-terms': 'Accepter les CGU',
  'verify-email': 'Verification email',
  register: 'Inscription',
  'reset-password': 'Reinitialisation mot de passe',
};

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function getPageName(pathname: string): string {
  const segments = pathname.split('/').filter(s => s && !UUID_REGEX.test(s) && s !== 'asset');

  for (let i = segments.length - 1; i >= 0; i--) {
    const name = PAGE_NAMES[segments[i]];
    if (name) return name;
  }

  if (segments.length > 0) {
    const last = PAGE_NAMES[segments[segments.length - 1]];
    if (last) return last;
  }

  return 'Accueil';
}

export function useMixpanelPageTracking(): void {
  const location = useLocation();
  const { consentForAnalytics } = useUserConsent();
  const previousRef = useRef<{ name: string; enteredAt: number } | null>(null);

  useEffect(() => {
    if (!consentForAnalytics) return;

    const pageName = getPageName(location.pathname);
    const now = Date.now();
    const previous = previousRef.current;
    const timeSpentSeconds = previous ? Math.round((now - previous.enteredAt) / 1000) : undefined;

    trackPageViewed(pageName, {
      previous_page: previous?.name,
      time_spent_seconds: timeSpentSeconds,
    });

    previousRef.current = { name: pageName, enteredAt: now };
  }, [location.pathname, consentForAnalytics]);
}
